export const adjustHeight = (elemRef: HTMLElement | null) => {
    if (elemRef) {
      elemRef.style.height = "0px";
      const scrollHeight = elemRef.scrollHeight;

      elemRef.style.height = scrollHeight + "px";
      elemRef.style.overflow = "hidden";
    }
}